<div class="row">
    <div class="col-sm-12">
        <ccl-section-wrapper>
            <ccl-content-section>
                <router-outlet></router-outlet>
            </ccl-content-section>
        </ccl-section-wrapper>
    </div>
</div>
